import { inject, NgModule } from '@angular/core';

import { TermsComponent } from './terms.component';
import { HeaderModule } from 'experian-header-frontend-components';
import { AlertModule, FooterModule } from 'experian-shared-frontend';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SedsHeaderUserModule, SedsLoadersSpinnerModule } from 'experian-design-system';
import { AuthGuardService } from '../../services/auth-guard.service';

const routes: Routes = [
  { 
    path: '', 
    component: TermsComponent, 
    pathMatch: 'full', 
    canActivate: [() => inject(AuthGuardService).canActivate()] 
  }
];

@NgModule({
  imports: [
    AlertModule,
    CommonModule,
    FooterModule,
    HeaderModule,
    RouterModule.forChild(routes),
    MatProgressSpinnerModule,
    MatIconModule,
    InlineSVGModule.forRoot({ baseUrl: '/meus-produtos' }),
    NgOptimizedImage,
    SedsLoadersSpinnerModule,
    SedsHeaderUserModule
  ],
  exports: [],
  declarations: [TermsComponent],
  providers: [],
})
export class TermsModule { }
